import { styled } from '@mui/material/styles';

import Paper from '@mui/material/Paper';

const StyledPaper = styled(Paper)(({ theme, square }) => ({
    borderRadius: square ? 0 : 12,
    transition: theme.transitions.create(['background-color', 'box-shadow']),
}));

export default StyledPaper;
